import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UserService} from '../user.service';

@Component({
  selector: 'app-approve-classification',
  templateUrl: './approve-classification.component.html',
  styleUrls: ['./approve-classification.component.css']
})
export class ApproveClassificationComponent implements OnInit {

  approvedissues: any;
  value = 'select';

  constructor(private http: HttpClient, private user: UserService) {
  }

  ngOnInit() {
    this.http.get('/issue/api/bystatus/1/1').subscribe(data => {
      this.approvedissues = data;
    });
  }

  add(id) {
    if (this.value === 'select' ) {

      this.http.get(encodeURI('issue/approvecorrect/' + id.toString()+ '/' + this.value.toString())).subscribe(data => {

        for (let i = 0; i < this.approvedissues.length; i++) {
          if (this.approvedissues[i].issueID === id) {
            this.approvedissues.splice(i, 1);
          }
        }

      });

    } else {

      this.http.get(encodeURI('issue/approvewrong/' + id.toString() + '/' + this.value.toString())).subscribe(data => {

        for (let i = 0; i < this.approvedissues.length; i++) {
          if (this.approvedissues[i].issueID === id) {
            this.approvedissues.splice(i, 1);
          }
        }

      });

    }

    this.value = 'select';

}

}



// WEBPACK FOOTER //
// ./src/app/approve-classification/approve-classification.component.ts